import React, { Component } from 'react';
import { connect } from 'react-redux';
import GirlAtComputer from '../../../../assets/images/girl-at-computer.jpg';
import './BelowBanner.scss';

class BelowBanner extends Component {
  render() {
    return (
      <section id="below-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-1 col-1">
              <p className="vertical-text">pixel8: creative agency</p>
            </div>
            <div className="col-lg-8 col-md-11 col-11 middle">
              <h2>Small Company Big Solutions</h2>

              <p className="large-first-letter">Pixel8 is a small agency located in north Georgia. We are a small team with large visions that execute enterprise level solutions.</p>
            </div>
            <div className="col-md-3 right">
              <div className="right-image">
                <img src={GirlAtComputer} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default connect()(BelowBanner);



// WEBPACK FOOTER //
// ./src/containers/HomePage/parts/BelowBanner/BelowBanner.js